import overviewMock from "@mocks/overview.json";
import etapasMock from "@mocks/etapas.json";
import driversMock from "@mocks/drivers.json";
import verbatinsMock from "@mocks/verbatins.json";
import tendenciasMock from "@mocks/tendencias.json";
import segmentacaoMock from "@mocks/segmentacao.json";
import benchmarkingMock from "@mocks/benchmarking.json";
import planosAcaoMock from "@mocks/planosAcao.json";
import cooperacaoMock from "@mocks/cooperacao.json";

const LATENCY = Number(import.meta.env.VITE_MOCK_LATENCY || 300);
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const respond = async (payload) => {
  await delay(LATENCY);
  return JSON.parse(JSON.stringify(payload));
};

export const mockAdapter = {
  getOverview:     () => respond(overviewMock),
  getJourney:      () => respond(etapasMock),
  getDrivers:      () => respond(driversMock),
  getVerbatins:    () => respond(verbatinsMock),
  getTrends:       () => respond(tendenciasMock),
  getSegmentation: () => respond(segmentacaoMock),
  getBenchmarking: () => respond(benchmarkingMock),
  getActionPlan:   () => respond(planosAcaoMock),
  getCooperacao:   () => respond(cooperacaoMock),
};
